// extracted by mini-css-extract-plugin
export default {"heading":"rz-z","corrected":"sz-z","redirectVerbiageContainer":"tz-z","redirectVerbiageText":"uz-z"};